import React, { useState } from 'react';
import { Button, Text, TextInput } from '@ui';
import { translate } from '@utils/i18n';
const NAMESPACE = 'features.settings.integrations.tce_template_diagnostic';
/**
 * Premise and optional inspection inputs for the template diagnostic.
 *
 * The inspection is optional but not decorative: credentials are resolved per
 * territory, so checking with the inspection you are actually submitting is
 * what makes the answer match what the wizard will do.
 */
function TemplateDiagnosticForm({ onSubmit, loading }) {
    const [premiseId, setPremiseId] = useState('');
    const [inspectionId, setInspectionId] = useState('');
    const submit = () => {
        if (premiseId.trim() === '')
            return;
        onSubmit(premiseId.trim(), inspectionId.trim());
    };
    return (React.createElement("div", { className: "tce-template-diagnostic__form" },
        React.createElement(TextInput, { id: "tce-diagnostic-premise-id", label: translate('premise_id', { namespace: NAMESPACE }), value: premiseId, onChange: (event) => setPremiseId(event.target.value) }),
        React.createElement(TextInput, { id: "tce-diagnostic-inspection-id", label: translate('inspection_id', { namespace: NAMESPACE }), value: inspectionId, onChange: (event) => setInspectionId(event.target.value) }),
        React.createElement(Text, { variant: "x-small", as: "p", className: "tce-template-diagnostic__hint" }, translate('inspection_id_hint', { namespace: NAMESPACE })),
        React.createElement("div", { className: "tce-template-diagnostic__actions" },
            React.createElement(Button, { variant: "primary", onClick: submit, disabled: loading || premiseId.trim() === '' }, translate(loading ? 'searching' : 'search', { namespace: NAMESPACE })))));
}
export default TemplateDiagnosticForm;
